import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './axios.config'
import reportWebVitals from './reportWebVitals';
import "react-datepicker/dist/react-datepicker.css";
import { BrowserRouter } from 'react-router-dom'
import { RoleFeatureProvider } from './context/RoleFeatureContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  {/* <React.StrictMode> */}
  <RoleFeatureProvider>
    <App />
  </RoleFeatureProvider>
  {/* </React.StrictMode> */}
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
